import React, {createContext, useCallback, useContext, useEffect, useState} from "react";
import {CustomerType, PaymentIntentType, SubscriptionType} from "../generated/graphql";

const BasketContext = createContext<any|null>(null);
const BasketContextData = createContext<any|null>(null);

export function useBasketContext():any {
    return useContext<any>(BasketContext);
}
export function useBasketDataContext():BasketContextValue {
    return useContext<BasketContextValue>(BasketContextData);
}

type BasketContextProps = React.PropsWithChildren<{}>;

export type BasketContextValue = {
    customer?:CustomerType,
    subscription?:SubscriptionType,
    paymentIntent?:PaymentIntentType
}


export function BasketContextProvider({children}: BasketContextProps) {
    const [basket,setBasket] = useState<BasketContextValue|null>(null);
    const setCustomer = useCallback((customer:CustomerType)=> {
        setBasket((oldBasket)=>{
            var newBasket = {...oldBasket};
            newBasket.customer = customer;
            delete newBasket.paymentIntent;
            delete newBasket.subscription;
            window.localStorage.setItem('basket',JSON.stringify(newBasket));
            return newBasket;
        });
    },[]);
    const setSubscription = useCallback((subscription:SubscriptionType)=> {
        setBasket((oldBasket)=>{
            var newBasket = {...oldBasket};
            newBasket.subscription = subscription;
            delete newBasket.paymentIntent;
            window.localStorage.setItem('basket',JSON.stringify(newBasket));
            return newBasket;
        });
    },[]);
    const setPaymentIntent = useCallback((paymentIntent:PaymentIntentType)=>{
        setBasket((oldBasket)=>{
            var newBasket = {...oldBasket};
            newBasket.paymentIntent = paymentIntent;
            window.localStorage.setItem('basket',JSON.stringify(newBasket));
            return newBasket;
        })
    },[])
    useEffect(()=>{
        const storedBasket = window.localStorage.getItem('basket');
//        console.log('BASKET IS',storedBasket);
        if(storedBasket && !basket) {
            setBasket(JSON.parse(storedBasket));
        }
    },[]);
    const [setters] = useState({setCustomer,setSubscription,setPaymentIntent});
    return (
        <BasketContext.Provider value={setters}>
        <BasketContextData.Provider value={basket}>
        {children}
        </BasketContextData.Provider>
    </BasketContext.Provider>);
}